import { Form, FormRule, Input } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { dateViewFormat } from "src/common/formats";
import { DatePickerString } from "src/components/DatePickerString";
import { debounce, DebounceCounter } from "src/common/debounce";
import { FormItemProps } from "antd/lib";
import { Planning2DatesStore } from "./Planning2DatesStore";
import styles from "./Planning2Dates.module.less";

type PropsPlanning2Dates = {
  store: Planning2DatesStore;
};

const validCounter: DebounceCounter = {};

export const Planning2Dates: React.FC<PropsPlanning2Dates> = observer(
  (props) => {
    const { store } = props;
    const { initialBegin, initialEnd } = store;
    const [form] = Form.useForm();
    const revalidate = () =>
      debounce(validCounter, 10, () => {
        form.resetFields();
        store.setBegin(initialBegin);
        form.setFieldValue("begin", store.begin);
        store.setEnd(initialEnd);
        form.setFieldValue("end", store.end);
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        form.validateFields().catch(() => {});
      });
    React.useEffect(() => {
      revalidate();
    }, [store, initialBegin, initialEnd]);
    const beginRules: FormItemProps["rules"] = [dateValidator(initialBegin)];
    const endRules: FormItemProps["rules"] = [dateValidator(initialEnd)];

    (store.reversed ? endRules : beginRules).unshift({
      required: true,
      message: "Необходимо указать дату",
    });

    return (
      <Form
        form={form}
        layout="vertical"
        className={styles.datesBox}
        size="small"
      >
        <Form.Item name="begin" label="Плановая дата начала" rules={beginRules}>
          <DatePickerString
            format={dateViewFormat()}
            disabled={store.disabledBegin}
            onChange={(newValue) => store.setBegin(newValue)}
          />
        </Form.Item>
        <Form.Item name="end" label="Плановая дата окончания" rules={endRules}>
          <DatePickerString
            format={dateViewFormat()}
            disabled={store.disabledEnd}
            onChange={(newValue) => store.setEnd(newValue)}
          />
        </Form.Item>
        <Form.Item label="Общая длительность плана (дни)">
          <Input disabled readOnly value={store.duration} />
        </Form.Item>
      </Form>
    );
  },
);

const dateValidator = (initialValue: unknown): FormRule => ({
  validator(_rule, value) {
    if ((value ?? "") !== initialValue) {
      return Promise.reject(
        Error(
          "⚠ Нажмите “Рассчитать план”, чтобы обновить плановые даты задач в таблице",
        ),
      );
    }
    return Promise.resolve();
  },
});
